import HARDCODE from '../../business-const/HardCode/HardCode'

import LABEL from '../../business-const/Label/Label'



const tabClienteFormList = ( formListRadioGroup, linhaFormList, linhaTipoLicenca, usuarioClienteSelecionadoAtivo,
    jsonUsuario, jsonAcessoCliente ) => {

    const tabClienteFormListAux = []

    let cont = 1

    if (formListRadioGroup === HARDCODE.formListPrimeiraReuniao) {

        if (linhaTipoLicenca.exibirSomentePrevidenciaPrivada === 'S') {

            tabClienteFormListAux.push(
                (cont++) + '. ' + LABEL.tabClienteFormListPrevidenciaPrivada,
            )

        } else {

            if (!jsonAcessoCliente.acessoCliente || jsonAcessoCliente.disponibilizarInclusaoRevisaoDadosBasicos) {
                
                tabClienteFormListAux.push(
                    (cont++) + '. ' + LABEL.tabClienteFormListDadosBasicos,
                )
            }

            if (
                    (!jsonAcessoCliente.acessoCliente || jsonAcessoCliente.disponibilizarRelatorioSimulacaoFinanceira) &&
                    usuarioClienteSelecionadoAtivo === 'S'
             ) {

                //if (linhaTipoLicenca.exibirSimulacaoFinanceira === "S") {
                
                tabClienteFormListAux.push(
                    (cont++) + '. ' + LABEL.tabClienteFormListSimulacaoFinanceira,
                )
                //}
            }

            //if (!jsonAcessoCliente.acessoCliente || jsonAcessoCliente.disponibilizarRelatorioEstudo) {

            //    if (linhaTipoLicenca.exibirEstudo === "S" && linhaFormList.exibirEstudo === "S") {

            //        tabClienteFormListAux.push(
            //            (cont++) + '. ' + LABEL.tabClienteFormListEstudo,
            //        )
            //    }
            //}

            if (!jsonAcessoCliente.acessoCliente && usuarioClienteSelecionadoAtivo === 'S') {

                //if (linhaTipoLicenca.exibirEstudo === "S" && linhaFormList.exibirGestaoPatrimonial === "S") {

                //    tabClienteFormListAux.push(
                //        (cont++) + '. ' + LABEL.tabClienteFormListGestaoPatrimonial,
                //    )
                //}

                tabClienteFormListAux.push(
                    (cont++) + '. ' + linhaFormList.labelTabClienteFormListConsideracoesFinais,
                )
            }

            if (
                    (
                        (!jsonAcessoCliente.acessoCliente && linhaFormList.reportPrimeiraReuniaoInvestimentoSeguroVida === "N" ) ||
                        jsonAcessoCliente.disponibilizarRelatorioEstudo
                    ) &&
                    usuarioClienteSelecionadoAtivo === 'S'
            ) {

                tabClienteFormListAux.push(
                    (cont++) + '. ' + LABEL.tabClienteFormListRelatorio,
                )
            }
            
            if (!jsonAcessoCliente.acessoCliente || jsonAcessoCliente.disponibilizarAcompanhamento) {

                tabClienteFormListAux.push(
                    (cont++) + '. ' + LABEL.tabClienteFormListAcompanhamento,
                )
            }
        }

    } else {

        if (jsonUsuario.utilizarEstudoCompleto) {

            tabClienteFormListAux.push(
                (cont++) + '. ' + LABEL.tabClienteFormListCadastro,
                (cont++) + '. ' + LABEL.tabClienteFormListFluxoCaixa,
                (cont++) + '. ' + LABEL.tabClienteFormListPatrimonio,
            )

        } else {

            tabClienteFormListAux.push(
                (cont++) + '. ' + LABEL.tabClienteFormListDadosBasicos,
            )
        }

        if (
                linhaTipoLicenca.exibirSimulacaoFinanceira === "S" &&
                jsonUsuario.utilizarSimulacaoFinanceiraEstudo &&
                usuarioClienteSelecionadoAtivo === 'S'
         ) {
            
            tabClienteFormListAux.push(
                (cont++) + '. ' + LABEL.tabClienteFormListSimulacaoFinanceira,
            )
        }

        //if (linhaFormList.exibirEstudo === "S") {

        if (usuarioClienteSelecionadoAtivo === 'S') {

            tabClienteFormListAux.push(
                (cont++) + '. ' + LABEL.tabClienteFormListEstudo,
            )
        }

        //}

        if (
                linhaFormList.exibirGestaoPatrimonial === "S" /*&&
                (jsonUsuario.nome === 'ALEXANDRE PUREZA' || jsonUsuario.nome === 'JORGE CANTARELLI FILHO') // provisorio*/
        ) {

            tabClienteFormListAux.push(
                (cont++) + '. ' + LABEL.tabClienteFormListGestaoPatrimonial,
            )
        }
            
        if (/*linhaTipoLicenca.exibirSomenteConsorcio === 'N' && */usuarioClienteSelecionadoAtivo === 'S') {

            tabClienteFormListAux.push(
                (cont++) + '. ' + linhaFormList.labelTabClienteFormListConsideracoesFinais,
            )
        }

        if (usuarioClienteSelecionadoAtivo === 'S') {

            tabClienteFormListAux.push(
                (cont++) + '. ' + LABEL.tabClienteFormListRelatorio,
            )
        }

        tabClienteFormListAux.push(
            (cont++) + '. ' + LABEL.tabClienteFormListAcompanhamento,
            //(cont++) + '. ' + 'Log Acesso Cliente'
        )
    }

    return tabClienteFormListAux
}

export default tabClienteFormList